import { motion } from "framer-motion";

export default function SectionHeading({ overline, title, desc, align = "left" }) {
  const centered = align === "center";
  return (
    <motion.div
      initial={{ opacity: 0, y: 28 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.15 }}
      transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
      className={centered ? "mx-auto max-w-3xl text-center" : "max-w-3xl"}
    >
      <p className={`overline-label flex items-center gap-3 ${centered ? "justify-center" : ""}`}>
        <span className="h-px w-8 bg-mint" />
        {overline}
      </p>
      <h2 className="mt-5 font-display text-3xl font-light leading-[1.08] tracking-tight sm:text-4xl lg:text-5xl">
        {title}
      </h2>
      {desc && <p className="mt-5 text-base leading-relaxed text-mist sm:text-lg">{desc}</p>}
    </motion.div>
  );
}
